import React, { useEffect, useRef, useState } from 'react';
import './admin-manage-games-landing.styles.scss';
import { getGamesFromDb } from '@/utils/getAdminData';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import AdminGameView from './admin-game-view.component';

const AdminManageGamesLanding = ({
    owners
}) => {

    const [ gamesToDisplay, setGamesToDisplay ] = useState(null);
    const [ count, setCount ] = useState(20);
    const navigate = useNavigate();
    const gamesRef = useRef();
    let gamesListener;

    useEffect(() => {
        getGames();

        return () => {
            if (gamesListener) gamesListener();
        }
    }, [])
    
    useEffect(() => {
        console.log(owners)
    }, [owners])

    async function getGames() {
        getCollectionFromDb({
            'collection': 'games',
            'callback': callback,
            'handleListener': handleListener
        })
        function callback(data, id) {
            gamesRef.current = {
                ...gamesRef.current,
                ...{[id]: data}
            }
            setGamesToDisplay(Object.values(gamesRef.current));
        }
        function handleListener(unsub) {
            gamesListener = unsub;
        }
    }

    return (
        <div className='manage-games-landing'>
            <Routes>
                <Route path='' element={
                    <div className='manage-games-content'>
                        <div className='section-title'>
                            <span>Manage Games</span>
                        </div>
                        <hr />
                        {
                            (gamesToDisplay && owners) 
                            ?
                            <table className='g-table'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Name</th>
                                        <th>Owner</th>
                                        <th>Activity</th>
                                        <th>Elements</th>
                                        <th>Players</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        gamesToDisplay
                                        .sort((a,b) => a.ts < b.ts ? 1 : -1)
                                        .filter(g => !g.template)
                                        .map(g => {
                                            const owner = owners[g.creatorId]
                                            return (
                                                <tr key={g.gameId}>
                                                    <td className='game-icon'>
                                                        <ImageContainer
                                                            src={g.icon}
                                                            />
                                                    </td>
                                                    <td>
                                                        <Link to={g.gameId}>
                                                            {g.gameName}
                                                        </Link>
                                                    </td>
                                                    <td>{
                                                        owner
                                                        ?
                                                        `${owner.fName} ${owner.lName}`
                                                        :
                                                        'Unknown'
                                                    }</td>
                                                    <td>{format(new Date(g.ts), "P")}</td>
                                                    <td>{g.createdElementTotal}</td>
                                                    <td>{g.playerCount}</td>
                                                    <td>
                                                        <div className="buttons">
                                                            <button 
                                                                className='g-button small-btn'
                                                                onClick={() => navigate(g.gameId)} >
                                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            :
                            <div className='center-col'>
                                <ThreeDotsLoader />
                            </div>
                        }
                    </div>
                }></Route>
                <Route path=':gameId/*' element={
                    <AdminGameView
                        games={gamesRef.current}
                        owners={owners} />
                }></Route>
            </Routes>
        </div>
    )
}

export default AdminManageGamesLanding